<template>
  <div id="comheader">
    <div class="headerTop  mainWidth">
      <div class="nav_header">
        <!-- <div class="nav_100years">
          <img src="../assets/images/100years.gif" alt="">
        </div> -->
        <div class="nav_log" @click="goHome"></div>
        <!-- <div class="nav_title"  @click="goHome">{{$t('common.companyName')}}</div> -->
        <div class="nav_bar">
          <img src="../assets/images/bar.jpg" alt="">
        </div>
        <div class="ISSF">
          <div class="ISSFLogin">
            <img src="../assets/images/ISSF.png" alt="">
          </div>
          <!--<div class="language">-->
            <!--<div class="lang_item" :class="lang=='zh'?'active':''" @click="changeLanguage('zh')">中</div>-->
            <!--<div class="lang_item"  :class="lang=='en'?'active':''" @click="changeLanguage('en')">EN</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="headerNav">
      <div class="nav_box mainWidth">
        <div class="nav_left">
          <mu-tabs  :value="activeTab" @change="handleTabChange" class="nav_bar">
            <mu-tab class="nav_item" v-for="(item,idx) in $t('comheader.nav')" :key="item.title" :value="idx" :title="item.title" @click="routeTo(item.url,idx)"/>
          </mu-tabs>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'comheader',
  data () {
    return {
      lang: this.$i18n.locale,
      activeTab:0,
      line:'line',
      titleClass:'titleClass',

    }
  },
  mounted(){
    this.setTab(this.$route.name)
  },
  watch:{
    '$route':'hashChange',
  },
  methods:{
      hashChange(to,from){
        this.setTab(to.name);
        window.scrollTo(0,0);
      },
      setTab(name){
          switch(name){
            case "home":
              this.activeTab=0
              break;
            case "etarget":
              this.activeTab=1
              break;
            case "lasershooting":
              this.activeTab=2
              break;
            case "erange":
              this.activeTab=2
              break;
            case "service":
              this.activeTab=3
              break;
              case "articlelist":
              this.activeTab=4
              break;
            case "intro":
              this.activeTab=5
              break;
            case "honor":
              this.activeTab=5
              break;
            case "customer":
              this.activeTab=5
              break;
            case "contact":
              this.activeTab=5
              break;
            default:
                this.activeTab='tab0'
          }
      },
      changeLanguage(lang){
          this.lang=lang;
          this.$i18n.locale=lang;
      },
      handleTabChange (val,ev) {
        this.activeTab = val;
      },
      routeTo(path,val){
        this.activeTab=val;
//        document.getElementById('comheader').style.backgroundColor="#2A385D";
        this.$router.push({path:path});
      },
      goHome(){
        this.activeTab="tab0";
        this.$router.push({name:"home"});
      }
  }
}
</script>

<style lang="less" scoped>
#comheader.fixed{
  position:fixed;
  background-color:#2A385D;
  z-index:99;
}
#comheader{
  width:100%;
  /*height:130px;*/
  // background: url("../assets/images/bar.jpg")  no-repeat top center;
  color: #222222;
  transition:all 500ms;
  box-shadow: 0 3px 3px rgba(0,0,0,0.15);
  background-size:50% 50%;
  background-position-x: 400px;
  background-position-y:5px;
  .headerTop{
    height:80px;
    .nav_header{
      height:inherit;
      vertical-align:middle;
      .nav_100years{
        height:80px;
        display:inline;
        float:left;
        img{
          height:80px;
        }
        
      }
      .nav_log{
        vertical-align: middle;
        margin-top:0px;
        height:80px;
        width:226px;
        float:left;
        background:url("../assets/images/logo.png") no-repeat center center;
        background-size:100% 100%;
        cursor:pointer;
      }
      .nav_bar{
        width:600px;
        height:80px;
        float:left;
        img{
          width:600px;
          height:60px;
          margin-top:10px;
        }

        

      }
      .nav_title{
        margin-left:17px;
        font:16px/20px #FFFFFF;
        height:20px;
        float:left;
        letter-spacing: 0;
        margin-top:35px;
        cursor:pointer;
      }
      .ISSF{
        width:150px;
        height:50px;
        float:right;
        display:inline-block;
        margin-top:20px;
        .ISSFLogin{
          float:right;
          width:195px;
          vertical-align: middle;
        }
        .language{
          float:right;
          height:28px;
          width:88px;
          padding-top:11px;
          .lang_item{
            background: #306988;
            width:28px;
            height:28px;
            float:right;
            line-height:28px;
            border-radius:50%;
            font-size: 11px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            cursor:pointer;
          }
          .lang_item:nth-last-child(1){
            margin-right:10px;
          }
          .active{
            background-color:#2095d4;

          }

        }
      }


    }
  }
  .headerNav{
    height:60px;
    background-color:#2095D4;

  }
  .titleClass{
    height: 60px!important;
    line-height:60px;
  }
  .nav_box{
    height:inherit;
    overflow:hidden;
    .nav_left{
      float:left;
      height:inherit;
      .nav_bar{
        float:left;
        display:block;
        .nav_item{
          padding-top:0px!important;
          float:left;
          height:inherit;
          line-height:60px;
          width:108px;
          font-size: 14px;
          letter-spacing: 0;
          cursor:pointer;
          color: #fff;
          letter-spacing:0;
        }
      }
    }
  }
}
</style>
<style lang="less">
  .mu-tabs{
    .mu-tab-link{
      padding:0;
      margin:0;
    }
    background-color:rgba(0,0,0,0)!important;
    height:60px!important;
    .mu-tab-text{
      height:60px;
      transition:all 500ms;
    }
    .mu-tab-active{
      background:rgba(0,0,0,0.3);
      background:#077CBC;
      .mu-tab-text{
        color:#9addf7;
        font-size:16px;
        line-height:60px;
      }
    }
  }
  .mu-ripple-wrapper{
    height:60px!important;
  }
  .line{
    background-color:RGBA(255,255,255,.3);
    border-top:4px solid #2095D4;
    top:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/comheader.vue